export type DreamBotRuntimeConfig = {
  siteId?: string; // Multi-tenant site identifier
  apiBaseUrl?: string;
  pluginBaseUrl?: string;
  assetsBaseUrl?: string;
  chatPath?: string;
  recommendationPath?: string;
  eventPath?: string;
  embedToken?: string;
  storeName?: string;
  brandName?: string;
  mountId?: string;
  showLanguageSelector?: boolean;
  showSettingsButton?: boolean;
  showTutorialButton?: boolean;
};

export const getDreamBotRuntimeConfig = (): DreamBotRuntimeConfig => {
  const cfg = (globalThis as any)?.DreamBotConfig;
  return cfg && typeof cfg === 'object' ? (cfg as DreamBotRuntimeConfig) : {};
};
